export interface FortarisModuloConfig {
  modulo: string;
  label: string;
  rota: string;
  permissaoVisualizar: string;
  icone: string;
  grupo: string;
  visivelMenu: boolean;
}

export const FORTARIS_MODULOS: FortarisModuloConfig[] = [
  {
    modulo: 'relatorios-planejamento',
    label: 'Planejamento',
    rota: '/relatorios/planejamento',
    permissaoVisualizar: 'relatorio.planejamento.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-suprimentos',
    label: 'Suprimentos',
    rota: '/relatorios/suprimentos',
    permissaoVisualizar: 'relatorio.suprimentos.visualizar',
    icone: 'pi pi-shopping-bag',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-almoxarifado',
    label: 'Almoxarifado',
    rota: '/relatorios/almoxarifado',
    permissaoVisualizar: 'relatorio.almoxarifado.visualizar',
    icone: 'pi pi-box',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-execucao',
    label: 'Execução',
    rota: '/relatorios/execucao',
    permissaoVisualizar: 'relatorio.execucao.visualizar',
    icone: 'pi pi-book',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-medicao',
    label: 'Medição',
    rota: '/relatorios/medicao',
    permissaoVisualizar: 'relatorio.medicao.visualizar',
    icone: 'pi pi-chart-line',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-financeiro',
    label: 'Financeiro',
    rota: '/relatorios/financeiro',
    permissaoVisualizar: 'relatorio.financeiro.visualizar',
    icone: 'pi pi-wallet',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-tesouraria',
    label: 'Tesouraria',
    rota: '/relatorios/tesouraria',
    permissaoVisualizar: 'relatorio.tesouraria.visualizar',
    icone: 'pi pi-building',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-cadastros-base',
    label: 'Cadastros Base',
    rota: '/relatorios/cadastros-base',
    permissaoVisualizar: 'relatorio.planejamento.visualizar',
    icone: 'pi pi-map',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'relatorios-administracao',
    label: 'Administração',
    rota: '/relatorios/administracao',
    permissaoVisualizar: 'relatorio.administracao.visualizar',
    icone: 'pi pi-cog',
    grupo: 'Relatórios',
    visivelMenu: true,
  },
  {
    modulo: 'manual-sistema',
    label: 'Manual do Sistema',
    rota: '/manual',
    permissaoVisualizar: 'manual-sistema.visualizar',
    icone: 'pi pi-book',
    grupo: 'Documentação',
    visivelMenu: true,
  },
  {
    modulo: 'empresa',
    label: 'Entidade',
    rota: '/empresa',
    permissaoVisualizar: 'empresa.visualizar',
    icone: 'pi pi-building',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'cidade',
    label: 'Cidade',
    rota: '/cidade',
    permissaoVisualizar: 'cidade.visualizar',
    icone: 'pi pi-map-marker',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'sinapi',
    label: 'Base SINAPI',
    rota: '/cadastros/sinapi/importacoes',
    permissaoVisualizar: 'sinapi-importacao.listar',
    icone: 'pi pi-database',
    grupo: 'Integrações',
    visivelMenu: true,
  },
  {
    modulo: 'sinapi-recursos',
    label: 'Recursos SINAPI',
    rota: '/cadastros/sinapi/recursos',
    permissaoVisualizar: 'sinapi-recurso.listar',
    icone: 'pi pi-box',
    grupo: 'Integrações',
    visivelMenu: true,
  },
  {
    modulo: 'sinapi-servicos',
    label: 'Serviços SINAPI',
    rota: '/cadastros/sinapi/servicos',
    permissaoVisualizar: 'sinapi-servico.listar',
    icone: 'pi pi-cog',
    grupo: 'Integrações',
    visivelMenu: true,
  },
  {
    modulo: 'sinapi-composicoes',
    label: 'Composições SINAPI',
    rota: '/cadastros/sinapi/composicoes',
    permissaoVisualizar: 'sinapi-composicao.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Integrações',
    visivelMenu: true,
  },
  {
    modulo: 'composicoes-proprias',
    label: 'Composições Próprias',
    rota: '/cadastros/sinapi/composicoes-proprias',
    permissaoVisualizar: 'orcamento-base.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Integrações',
    visivelMenu: true,
  },
  {
    modulo: 'dashboard-projetos',
    label: 'Dashboard',
    rota: '/projetos-dashboard',
    permissaoVisualizar: 'projeto.visualizar',
    icone: 'pi pi-chart-bar',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'projeto',
    label: 'Projetos',
    rota: '/projetos',
    permissaoVisualizar: 'projeto.visualizar',
    icone: 'pi pi-briefcase',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'padrao-base-unidade',
    label: 'Cadastro de Execução',
    rota: '/padroes-base-unidade',
    permissaoVisualizar: 'execucao-projeto.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'orcamento-base',
    label: 'Orçamento',
    rota: '/orcamentos-base',
    permissaoVisualizar: 'orcamento-base.listar',
    icone: 'pi pi-book',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'tipo-projeto',
    label: 'Tipo de Projeto',
    rota: '/tipos-projeto',
    permissaoVisualizar: 'tipo-projeto.visualizar',
    icone: 'pi pi-tags',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'unidades',
    label: 'Unidades',
    rota: '/unidades',
    permissaoVisualizar: 'unidades.visualizar',
    icone: 'pi pi-th-large',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'necessidade',
    label: 'Dashboard',
    rota: '/necessidade',
    permissaoVisualizar: 'necessidade.visualizar',
    icone: 'pi pi-chart-bar',
    grupo: 'Compras',
    visivelMenu: true,
  },
  {
    modulo: 'fornecedor',
    label: 'Fornecedores',
    rota: '/compras/fornecedores',
    permissaoVisualizar: 'fornecedor.visualizar',
    icone: 'pi pi-truck',
    grupo: 'Compras',
    visivelMenu: true,
  },
  {
    modulo: 'cotacao',
    label: 'Cotação',
    rota: '/compras/cotacoes',
    permissaoVisualizar: 'cotacao.visualizar',
    icone: 'pi pi-calculator',
    grupo: 'Compras',
    visivelMenu: true,
  },
  {
    modulo: 'pedido-compra',
    label: 'Pedido de Compra',
    rota: '/pedido-compra',
    permissaoVisualizar: 'pedido-compra.visualizar',
    icone: 'pi pi-file-edit',
    grupo: 'Compras',
    visivelMenu: true,
  },
  {
    modulo: 'almoxarifado',
    label: 'Dashboard',
    rota: '/almoxarifado/dashboard',
    permissaoVisualizar: 'almoxarifado.visualizar',
    icone: 'pi pi-chart-bar',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'recebimento',
    label: 'Recebimento',
    rota: '/almoxarifado/recebimentos',
    permissaoVisualizar: 'recebimento.visualizar',
    icone: 'pi pi-inbox',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'almoxarifado-movimentacoes',
    label: 'Movimentações',
    rota: '/almoxarifado/movimentacoes',
    permissaoVisualizar: 'almoxarifado.visualizar',
    icone: 'pi pi-directions',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'almoxarifado-estoque',
    label: 'Estoque',
    rota: '/almoxarifado/estoque',
    permissaoVisualizar: 'almoxarifado.visualizar',
    icone: 'pi pi-box',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'almoxarifado-locais',
    label: 'Locais de estoque',
    rota: '/almoxarifado/locais',
    permissaoVisualizar: 'almoxarifado.visualizar',
    icone: 'pi pi-map-marker',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'almoxarifado-tipos-movimentacao',
    label: 'Tipos de movimentação',
    rota: '/almoxarifado/tipos-movimentacao',
    permissaoVisualizar: 'almoxarifado.visualizar',
    icone: 'pi pi-sliders-h',
    grupo: 'Almoxarifado',
    visivelMenu: true,
  },
  {
    modulo: 'dashboard-diario-obra-medicao',
    label: 'Dashboard Diário/Medição',
    rota: '/execucao/dashboard-medicoes-evolucoes',
    permissaoVisualizar: 'dashboard-medicao.visualizar',
    icone: 'pi pi-chart-line',
    grupo: 'Execução',
    visivelMenu: true,
  },
  {
    modulo: 'diario-obra',
    label: 'Diário de Obra',
    rota: '/execucao/diario-obra',
    permissaoVisualizar: 'diario-obra.visualizar',
    icone: 'pi pi-book',
    grupo: 'Execução',
    visivelMenu: true,
  },
  {
    modulo: 'medicao',
    label: 'Medição',
    rota: '/execucao/medicoes',
    permissaoVisualizar: 'medicao.visualizar',
    icone: 'pi pi-chart-line',
    grupo: 'Execução',
    visivelMenu: true,
  },
  {
    modulo: 'dashboard-financeiro',
    label: 'Dashboard Financeiro',
    rota: '/dashboard-financeiro',
    permissaoVisualizar: 'financeiro.visualizar',
    icone: 'pi pi-chart-bar',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'financeiro',
    label: 'Financeiro',
    rota: '/financeiro',
    permissaoVisualizar: 'financeiro.visualizar',
    icone: 'pi pi-chart-line',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'requisicao-financeira',
    label: 'Requisições Financeiras',
    rota: '/requisicoes-financeiras',
    permissaoVisualizar: 'requisicao-financeira.listar',
    icone: 'pi pi-file-edit',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'contas-pagar',
    label: 'Contas a Pagar',
    rota: '/contas-pagar',
    permissaoVisualizar: 'contas-pagar.visualizar',
    icone: 'pi pi-credit-card',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'contas-receber',
    label: 'Contas a Receber',
    rota: '/contas-receber',
    permissaoVisualizar: 'contas-receber.visualizar',
    icone: 'pi pi-wallet',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'tesouraria-conta-bancaria',
    label: 'Contas Bancárias',
    rota: '/tesouraria/contas-bancarias',
    permissaoVisualizar: 'tesouraria-conta-bancaria.listar',
    icone: 'pi pi-building',
    grupo: 'Tesouraria',
    visivelMenu: true,
  },
  {
    modulo: 'tesouraria-projeto-conta-bancaria',
    label: 'Vínculo Conta x Projeto',
    rota: '/tesouraria/vinculos-conta-projeto',
    permissaoVisualizar: 'tesouraria-projeto-conta-bancaria.listar',
    icone: 'pi pi-link',
    grupo: 'Tesouraria',
    visivelMenu: true,
  },
  {
    modulo: 'tesouraria-movimentacao',
    label: 'Movimentações Bancárias',
    rota: '/tesouraria/movimentacoes-bancarias',
    permissaoVisualizar: 'tesouraria-movimentacao.listar',
    icone: 'pi pi-directions',
    grupo: 'Tesouraria',
    visivelMenu: true,
  },
  {
    modulo: 'tesouraria-conciliacao',
    label: 'Conciliação Bancária',
    rota: '/tesouraria/conciliacao-bancaria',
    permissaoVisualizar: 'tesouraria-conciliacao.listar',
    icone: 'pi pi-check-square',
    grupo: 'Tesouraria',
    visivelMenu: true,
  },
  {
    modulo: 'tesouraria-extrato',
    label: 'Extratos Bancários',
    rota: '/tesouraria/extratos-bancarios',
    permissaoVisualizar: 'tesouraria-extrato.visualizar',
    icone: 'pi pi-file',
    grupo: 'Tesouraria',
    visivelMenu: true,
  },
];

export const FORTARIS_MODULOS_CADASTRO: FortarisModuloConfig[] = [
  {
    modulo: 'usuario',
    label: 'Usuário',
    rota: '/cadastros/usuarios',
    permissaoVisualizar: 'usuario.listar',
    icone: 'pi pi-users',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'perfil',
    label: 'Perfil',
    rota: '/cadastros/perfis',
    permissaoVisualizar: 'perfil.listar',
    icone: 'pi pi-id-card',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'fase',
    label: 'Fase',
    rota: '/cadastros/fases',
    permissaoVisualizar: 'fase.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'material',
    label: 'Recursos',
    rota: '/cadastros/recursos',
    permissaoVisualizar: 'material.visualizar',
    icone: 'pi pi-box',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'cliente',
    label: 'Clientes',
    rota: '/cadastros/clientes',
    permissaoVisualizar: 'cliente.visualizar',
    icone: 'pi pi-user',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'tipo-operario',
    label: 'Tipo de Operário',
    rota: '/cadastros/tipos-operario',
    permissaoVisualizar: 'tipo-operario.listar',
    icone: 'pi pi-users',
    grupo: 'Cadastros',
    visivelMenu: true,
  },
  {
    modulo: 'diaria-operario-projeto',
    label: 'Diária por Projeto',
    rota: '/cadastros/diarias-operario-projeto',
    permissaoVisualizar: 'diaria-operario-projeto.listar',
    icone: 'pi pi-money-bill',
    grupo: 'Obras',
    visivelMenu: true,
  },
  {
    modulo: 'forma-pagamento',
    label: 'Forma de Pagamento',
    rota: '/cadastros/formas-pagamento',
    permissaoVisualizar: 'forma-pagamento.visualizar',
    icone: 'pi pi-credit-card',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'financeiro-plano-conta',
    label: 'Plano de Contas',
    rota: '/cadastros/planos-conta',
    permissaoVisualizar: 'financeiro-plano-conta.visualizar',
    icone: 'pi pi-sitemap',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'financeiro-centro-custo',
    label: 'Centro de Custo',
    rota: '/cadastros/centros-custo',
    permissaoVisualizar: 'financeiro-centro-custo.visualizar',
    icone: 'pi pi-briefcase',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
  {
    modulo: 'condicao-pagamento',
    label: 'Condição de Pagamento',
    rota: '/cadastros/condicoes-pagamento',
    permissaoVisualizar: 'condicao-pagamento.visualizar',
    icone: 'pi pi-calendar',
    grupo: 'Financeiro',
    visivelMenu: true,
  },
];

export const FORTARIS_GRUPOS_MENU = [
  'Cadastros',
  'Integrações',
  'Planejamento',
  'Obras',
  'Compras',
  'Almoxarifado',
  'Execução',
  'Financeiro',
  'Tesouraria',
  'Relatórios',
  'Documentação',
];
